import restClient from 'config/httpClient';
import { call, fork, put, takeLatest } from 'redux-saga/effects';

import { PATH, PATH_NAME } from 'constants/Routes';

import { putRequestErrors } from 'modules/utils';

import * as actions from 'modules/customers/actions';

import * as actionTypes from 'modules/customers/actionTypes';

function* startApplication() {
  if (PATH[PATH_NAME.CUSTOMER_LEAD_UNSUBSCRIBE].match(window.location.pathname)) {
    yield put(actions.postUnsubscribe());
  }
}

/**
 * @param {import('./types').PostUnsubscribeAction} params
 */
function* postUnsubscribe({ payload }) {
  const { request } = payload;

  try {
    const { data: unsubscribeData } = yield call(restClient.request, request);
    yield put(actions.postUnsubscribeSuccess(unsubscribeData));
  } catch (error) {
    const isAxiosError = error?.isAxiosError && error.response?.data;
    yield put(actions.postUnsubscribeFailure(isAxiosError ? error.response?.data : error));
    yield call(putRequestErrors, error);
  }
}

export default function* customersSagas() {
  yield takeLatest(actionTypes.POST_CUSTOMER_LEADS_UNSUBSCRIBE, postUnsubscribe);
  yield fork(startApplication);
}
